export enum RouteQueryParamTargetApp {
  Admin = '68ff4c5f-5ce8-45da-9281-88ced5cca1f7',
  SSO = '72a53f9b-596c-4f72-8f35-449148db2e07',
  Shop = '9d8292ae-de57-41fd-a9d0-2f93f85e949a',
}
